import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { expertSolutionList } from 'data/street';

SwiperCore.use([Navigation, Pagination]);

/**
 * Expert Solution 데이터 리스트를 특정 타입별로 정렬 합니다.
 */
const getSortFilterList = (type: number) => {
  const returnSortFilterList: any[] = [];
  for (const es of expertSolutionList) {
    if (es.type == type) {
      returnSortFilterList.push(es);
    }
  }
  return returnSortFilterList;
};

const getTypeTitle = (type: number) => {
  if (type === 1) {
    return '안전 시스템';
  } else if (type === 2) {
    return '절약 시스템';
  } else if (type === 3) {
    return '건강 시스템';
  } else if (type === 4) {
    return '편의 시스템';
  } else if (type === 5) {
    return '소음저감 시스템';
  } else {
    return '';
  }
};

interface Props {
  type: number;
}

export default function OfferTechnologySlide({ type }: Props) {
  const RenderSlideList = () => {
    return getSortFilterList(type).map(({ title, description, img }, key) => {
      return (
        <SwiperSlide key={key}>
          <div className="system-area">
            <img src={img} alt="상품 이미지" />
            <div className="hover-contents">
              <div className="title expert_solution">{title}</div>
              <div className="desc">{description}</div>
            </div>
          </div>
        </SwiperSlide>
      );
    });
  };

  return (
    <>
      {getSortFilterList(type).length !== 0 && <div className="system-slide-title">{getTypeTitle(type)}</div>}
      <Swiper
        pagination={{
          dynamicBullets: true
        }}
        preventClicks={false}
        navigation={false}
        slidesPerView={1.05}
        spaceBetween={25}
        className="offer-swiper">
        {RenderSlideList()}
      </Swiper>
    </>
  );
}
